export default {"src":"/_next/static/media/SpaceIcon3White.444c8e7e.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};